interface PageHeroProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}

const defaultBackgroundImage = '/assets/readdy/hero-church-interior-001-efa98afb613e.jpg';

export default function PageHero({ title, subtitle, backgroundImage = defaultBackgroundImage }: PageHeroProps) {
  return (
    <div className="relative h-[280px] sm:h-[340px] md:h-[400px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src={backgroundImage} 
          alt={title} 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#3d1a1e]/80 via-[#3d1a1e]/60 to-[#3d1a1e]/80"></div>
      </div>
      <div className="relative z-10 text-center px-4 sm:px-6 pt-12 sm:pt-16">
        <h1 className="text-3xl sm:text-4xl md:text-6xl font-serif font-bold text-white mb-3 sm:mb-4">{title}</h1>
        {subtitle && (
          <p className="text-sm sm:text-lg md:text-xl text-white/90 max-w-2xl mx-auto">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
